module.exports = __webpack_public_path__ + "static/media/metronom-blue.504c0c39.svg";